import { Injectable } from '@angular/core';
import { ThemeActionsService } from './theme-actions.service';
import { VIDEO_TARGET, VideoOverlayService } from '@shared/components/video-overlay/video-overlay.service';
import { IoService } from '@core/services/io.service';

@Injectable({
  providedIn: 'root',
})
export class NetflixWednesdayActionsService extends ThemeActionsService {
  private readonly WEDNESDAY_SERCRET_PHRASE_ID = 'netflix-wednesday';
  private readonly WEDNESDAY_MEAL_PHRASE_ID = 'netflix-wednesday-meal';

  constructor(private videoOverlayService: VideoOverlayService, private ioService: IoService) {
    super();
    this.setThemeId('netflix-wednesday');
  }

  public override triggerThemePhraseActions(callback: Function, phraseId: string) {
    if (!this.hasPhraseActionsTriggered(phraseId)) {
      if (phraseId === this.WEDNESDAY_SERCRET_PHRASE_ID) {
        this.triggerSecretPhraseActions(callback);
        this.setPhraseActionsTriggered(phraseId, true);
      } else if (phraseId === this.WEDNESDAY_MEAL_PHRASE_ID) {
        this.triggerMealOfMisfortuneOrderVideo(callback);
        this.setPhraseActionsTriggered(phraseId, true);
      } else {
        // A phrase was triggered from the Proxy, but we don't have a handler for it
        callback();
      }
    } else {
      callback();
    }
  }

  private triggerSecretPhraseActions(callback: Function) {
    this.videoOverlayService.startVideoOverlay({
      src: './../../../../assets/videos/wednesday-phrase-video.webm',
      targetId: VIDEO_TARGET.Global,
      callback: callback,
    });
    // TODO: Re-enable once we confirm proxy can play audio separate from agentStream
    // this.ioService.sendCustomAudio(sessionId, 'test-wav')
  }

  private triggerMealOfMisfortuneOrderVideo(callback: Function) {
    this.videoOverlayService.startVideoOverlay({
      src: './../../../../assets/videos/wednesday-mom-video.webm',
      targetId: VIDEO_TARGET.Global,
      callback: callback,
    });
    // TODO: Re-enable once we confirm proxy can play audio separate from agentStream
    // this.ioService.sendCustomAudio(sessionId, 'test-wav')
  }
}
